import moment from "moment";
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { compact, filter, last, map, padStart } from "lodash";

import Assignment from "@material-ui/icons/Assignment";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import { numberToBRL } from "services/utils";

const styles = {
  firstCell: {
    whiteSpace: "pre-wrap",
  },
};

const DRE = ({ classes, dre }) => {
  const getPadStart = str => {
    const countDots = filter(str, char => char === ".").length;
    return !countDots ? str : padStart(str, str.length + countDots * 3);
  };

  const getData = () => {
    const itens = last(dre).itens;
    const penultimateYearItens = penultimateYear();

    return compact(map(itens, (item, index) => ([
      getPadStart(item.codigo),
      item.descricao,
      numberToBRL(item.valor),
      penultimateYearItens && numberToBRL(penultimateYearItens.itens[index].valor),
    ])));
  };

  const getTableHeaders = () => {
    const { dataInicio } = last(dre);
    const lastYearLabel = moment(dataInicio).format('YYYY');
    const penultimateYearItens = penultimateYear();
    const penultimateYearLabel = penultimateYearItens && `Ano Anterior (${moment(penultimateYearItens.dataInicio).format('YYYY')})`;

    return compact(["Código", "Descrição", lastYearLabel, penultimateYearLabel]);
  };

  const penultimateYear = () => {
    return dre.length > 1 && dre[dre.length - 2];
  };

  return (
    <GridContainer>
      <GridItem md={12} sm={12} xs={12}>
        <ECCard
          content={
            <Table
              customCellClasses={[classes.firstCell]}
              customClassesForCells={[0]}
              tableData={getData()}
              tableHead={getTableHeaders()}
              tableHeaderColor="primary"
            />
          }
          icon={<Assignment />}
          title="DRE"
        />
      </GridItem>
    </GridContainer>
  );
};

DRE.propTypes = {
  classes: PropTypes.object.isRequired,
  dre: PropTypes.arrayOf(PropTypes.shape({
    dataInicio: PropTypes.string.isRequired,
    dataFim: PropTypes.string.isRequired,
    itens: PropTypes.arrayOf(PropTypes.shape({
      codigo: PropTypes.string.isRequired,
      descricao: PropTypes.string.isRequired,
      valor: PropTypes.number.isRequired,
    })),
  })).isRequired,
};

export { DRE as DREComponent };
export default withStyles(styles)(DRE);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/DRE.jsx